import React, { useState } from "react";
import { Link } from "react-router-dom";

const Dropdown = ({ title, items, iconClass, link, closeMenu }) => {
  const [open, setOpen] = useState(false);
  let timeout;

  const handleEnter = () => {
    clearTimeout(timeout);
    setOpen(true);
  };

  const handleLeave = () => {
    timeout = setTimeout(() => setOpen(false), 200);
  };

  return (
    <li
      className="services-item"
      onMouseEnter={handleEnter}
      onMouseLeave={handleLeave}
    >
      <Link 
        to={link} 
        className="services-toggle"
        onClick={closeMenu}
      >
        <i className={`${iconClass} menu-icon`}></i> {title}
        <i className={`bi bi-caret-down-fill arrow ${open ? "open" : ""}`}></i>
      </Link>

      <ul className={`dropdown-menu ${open ? "show" : ""}`}>
        {items.map((item, index) => (
          <li key={index}>
            <Link 
              to={`/services#${item.id}`}
              onClick={closeMenu}
            >
              {item.name}
            </Link>
          </li>
        ))}
      </ul>
    </li>
  );
};



/* 🔥 MEGA DROPDOWN */
const MegaDropdown = ({ title, menu, closeMenu }) => {
  const [open, setOpen] = useState(false);
  let timeout;

  const handleEnter = () => {
    clearTimeout(timeout);
    setOpen(true);
  };

  const handleLeave = () => {
    timeout = setTimeout(() => setOpen(false), 200);
  };

  return (
    <li
      className="mega-menu"
      onMouseEnter={handleEnter}
      onMouseLeave={handleLeave}
    >
      <span className="services-toggle">
        {title}
        <i className={`bi bi-caret-down-fill arrow ${open ? "open" : ""}`}></i>
      </span>

      <div className={`mega-dropdown ${open ? "show" : ""}`}>
        <div className="mega-grid">
          {menu.map((section, index) => (
            <div className="mega-column" key={index}>
              <h4>
                <i className={section.icon}></i> {section.title}
              </h4>
              <ul>
                {section.items.map((item, i) => (
                  <li key={i}>
                    <a href="#" onClick={closeMenu}>
                      {item}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </li>
  );
};


const Navbar = () => {

const [menuOpen, setMenuOpen] = useState(false);

const closeMenu = () => {
  setMenuOpen(false);
};

const servicesItems = [
  { name: "Mobile Apps", id: "mobile" },
  { name: "Web Development", id: "web" },
  { name: "Uiux Design", id: "uiux" },
   { name: "Digital Marketing", id: "marketing" },
];

const technologyMenu = [
  {
    title: "Mobile",
    items: ["iOS", "Android", "Flutter", "Kotlin"],
    icon: "bi bi-phone",
  },
  {
    title: "Backend",
    items: ["Node js", "Laravel", "Python"],
    icon: "bi bi-server",
  },
  {
    title: "Front End",
    items: ["React js", "Vue js", "HTML5", "CSS3"],
    icon: "bi bi-code-slash",
  },
  {
    title: "Database",
    items: ["MySQL", "MongoDB"],
    icon: "bi bi-database",
  },
  {
  title: "UI-UX Design",
  items: [
    "Mobile App Design",
    "Website UI Design",
    "User Experience Optimization",
    "Responsive Design"
  ],
  icon: "bi bi-palette",
},
 {
  title: "Digital Marketing",
  items: [
    "Search Engine Optimization (SEO)",
    "Social Media Marketing",
    "Google Ads",
    "Facebook & Instagram Ads"
  ],
  icon: "bi bi-megaphone",
}
];

  return (
    <nav className="navbar">

      <h2 className="footer-logo">
        Lifetime <span>Infotech</span>
      </h2>

      {/* Hamburger */}
      <div 
      className={`hamburger ${menuOpen ? "active" : ""}`}
      onClick={()=>setMenuOpen(!menuOpen)}
      >
        <span></span>
        <span></span>
        <span></span>
      </div>

      <ul className={`navbar-menu ${menuOpen ? "active" : ""}`}>

        <li>
          <Link to="/home" onClick={closeMenu}>
            <i className="bi bi-house-door-fill menu-icon"></i> Home
          </Link>
        </li>

        <li>
          <Link to="/about" onClick={closeMenu}>
            <i className="bi bi-info-circle-fill menu-icon"></i> About Us
          </Link>
        </li>

        <Dropdown
          title="Services"
          items={servicesItems}
          iconClass="bi bi-tools-fill"
          link="/services"
          closeMenu={closeMenu}
        />

        <MegaDropdown 
          title="Technology" 
          menu={technologyMenu}
          closeMenu={closeMenu}
        />

        <li>
          <Link to="/portfolio" onClick={closeMenu}>
            <i className="bi bi-briefcase-fill menu-icon"></i> Portfolio
          </Link>
        </li>

        <li>
          <Link to="/contact1" onClick={closeMenu}>
            <i className="bi bi-envelope-fill menu-icon"></i> Contact Us
          </Link>
        </li>

      </ul>

    </nav>
  );
};

export default Navbar;